import { render, staticRenderFns } from "./AlertCardComponent.vue?vue&type=template&id=323a66da&scoped=true"
import script from "./AlertCardComponent.js?vue&type=script&lang=js&external"
export * from "./AlertCardComponent.js?vue&type=script&lang=js&external"
import style0 from "./AlertCardComponent.vue?vue&type=style&index=0&id=323a66da&prod&lang=scss&scoped=true"
import style1 from "./AlertCardComponent.vue?vue&type=style&index=1&id=323a66da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323a66da",
  null
  
)

export default component.exports